import React from 'react';
import styles from 'pages/studyOverview/containers/StudyDocuments/StudyDocuments.scss';

import { Files } from 'binder/containers';
import Sidebar from 'binder/components/Sidebar/Sidebar';

class StudyDocuments extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            links: [],
            iconClass: '',
            isCollapsed: false,
        };

        this.setSidebarLinks = this.setSidebarLinks.bind(this);
        this.setSidebarIcons = this.setSidebarIcons.bind(this);
        this.setSidebarCollapsed = this.setSidebarCollapsed.bind(this);
    }

    setSidebarLinks(links){
        if(!Array.isArray(links)){
            return;
        }

        this.setState({
            links
        });
    }

    setSidebarIcons(iconClass){
        this.setState({
            iconClass
        });
    }

    setSidebarCollapsed(isCollapsed) {
        this.setState({
            isCollapsed
        });
    }

    getFileContainerStyle() {
        const { fixedNav } = this.props;
        const { isCollapsed } = this.state;
        const isFixedNavWithCollapsedSidebar = fixedNav && isCollapsed;
        const isFixedNavWithoutCollapsedSidebar = fixedNav && !isCollapsed;
        const notFixedNavWithCollapsedSidebar = !fixedNav && isCollapsed;
        const notFixedNavWithoutCollapsedSidebar = !fixedNav && !isCollapsed;

        if(isFixedNavWithCollapsedSidebar) {
            return styles.stuckContentFullWidth;
        }

        if(notFixedNavWithCollapsedSidebar) {
            return styles.content;
        }

        if(isFixedNavWithoutCollapsedSidebar) {
            return styles.stuckContent;
        }

        if(notFixedNavWithoutCollapsedSidebar) {
            return styles.contentFullWidth;
        }
    }

    render() {
        const { links, iconClass, isCollapsed } = this.state;
        const { binder, fixedNav } = this.props;
        const sidebarProps = {
            links,
            title: binder.title,
            iconClass,
            isCollapsed,
            fixedNav,
            fromStudy: true,
        };

        return (
            <div className={styles.StudyDocumentsContainer} data-cy="StudyDocuments">
                <Sidebar {...sidebarProps} />
                <div className={this.getFileContainerStyle()} data-cy="StudyDocumentsdiv">
                    <Files 
                        {...this.props} 
                        setSidebarLinks={this.setSidebarLinks}
                        setSidebarIcons={this.setSidebarIcons}
                        setSidebarCollapsed={this.setSidebarCollapsed} />
                </div>
            </div>
        );
    }
}

export default StudyDocuments;
